<template>
  <div>
    <UserHeader></UserHeader>
    <div class="user_change_password content-area">
      <h2>{{ $t('meta_title.user.add_indispo') }}</h2>

      <div class="user_form">
        <form @submit.prevent="checkForm" method="post">
          <div class="form-group">
            <label for="begin_date" class="required">{{ $t('object.unavailability.begin_date') }}</label>
            <input type="datetime-local" id="begin_date" name="begin_date" required class="form-control"
            v-model="begin_date" required novalidate>
          </div>

          <div class="form-group">
            <label for="end_date" class="required">{{ $t('object.unavailability.end_date') }}</label>
            <input type="datetime-local" id="end_date" name="end_date" required class="form-control"
            v-model="end_date" required novalidate>
          </div>

          <button type="submit" class="change-password__btn btn">
            <span class="btn__text">Valider</span>
            <img src="/static/img/pictos/valider.svg" class="btn__picto" alt="">
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import UserHeader from "@/components/User/UserHeader";

  export default {
    name: 'UserAddIndispo',
    data() {
      return {
        begin_date: (new Date(Date.now() - ((new Date()).getTimezoneOffset() * 60000))).toISOString().slice(0,-1).slice(0,16),
        end_date: (new Date(Date.now() - ((new Date()).getTimezoneOffset() * 60000))).toISOString().slice(0,-1).slice(0,16),
      }
    },
    components: {
      UserHeader
    },
    methods: {
      checkForm: function (e) {
        if (this.begin_date > this.end_date) {
        }else{
          this.post()
        }
      },
      post(){
        this.$http.post('unavailability/', {
          begin_date: this.begin_date,
          end_date: this.end_date,
        }).then(response => {
          this.$store.dispatch('auth/getCurrentUser');
          this.$router.push({ name: "Profile" });
        })
      },
    }
  }
</script>


<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  .content-area{ width: 100%; margin-right: 0; padding: 0 20px; margin-top: 30px;
    h2{ font-family: 'ClanPro'; color: $color1; font-size: 20px; margin-bottom: 30px; position: relative; padding-bottom: 5px; border-bottom: 1px solid $color2; }

    label{ font-size: 12px; }

    .change-password__btn{ width: 100%; display: flex; flex-wrap: wrap; flex-direction: row; align-items: center; text-align: center; justify-content: space-between; height: 50px; color: white; background-color: $vert;  margin-top: 40px; border-radius: 0; outline: none;
      img{ width: 25px; margin-left: 5px; }
      span{ font-size: 12px; font-family: 'ClanPro'; }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/User/UserAddIndispo.vue